import React/*, { useState, useEffect, Fragment }*/ from 'react';
import { Dialog, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Kpis from '../Kpis';

export default function DashboarDialog(props) {
    const showDashboard = props.showDashboard || false
    const isAdmin = props.isAdmin
    const userId = props.userId

    const handleClose = () => {
        props.setShowDashboard(false)
    }

    return (
        <Dialog
            open={showDashboard}
            onClose={handleClose}
            fullScreen
        >
            <Paper style={{margin:'0 4px', padding: 8, display: 'flex', alignItems: 'center'}} elevation={1}>
                <div style={{flex: "1 1 0%"}}></div>
                <Kpis isAdmin={isAdmin} userId={userId}/>
                <IconButton aria-label="close" color="primary" onClick={handleClose} size="large">
                    <CloseIcon/>
                </IconButton>
            </Paper>
        </Dialog>
    );
}